import { errorTypes, standaloneErrorMessages } from 'catering/constants/errors';
import {
  CART_CHECKOUT_LABEL,
  CART_INVALID_ADDRESS_LABEL,
  CART_INVALID_FULFILLMENT_TIME_LABEL,
  CART_INVALID_ORDER_MINIMUM_LABEL,
  CART_PICKUP_ADDRESS_CHANGED_LABEL
} from 'constants/cart';

export function getCartCheckoutButtonLabel(errorType = null) {
  switch (errorType) {
    case errorTypes.ADDRESS_VALIDATION_ERROR:
    case errorTypes.LOW_INVENTORY:
      return CART_INVALID_ADDRESS_LABEL;
    case errorTypes.INVALID_FULFILLMENT_TIME:
      return CART_INVALID_FULFILLMENT_TIME_LABEL;
    case errorTypes.ORDER_MINIMUM_NOT_MET:
      return CART_INVALID_ORDER_MINIMUM_LABEL;
    case errorTypes.PICKUP_ADDRESS_CHANGED:
      return CART_PICKUP_ADDRESS_CHANGED_LABEL;
    default:
      return CART_CHECKOUT_LABEL;
  }
}

export function continueOrRefresh(errorType = null) {
  if (errorType === errorTypes.CART_IS_EMPTY) {
    window.location.reload();
  }
}

export function isCartCouldNotBeFoundError(errorMessage) {
  return (
    errorMessage.startsWith(
      standaloneErrorMessages.CART_COULD_NOT_BE_FOUND.start
    ) &&
    errorMessage.endsWith(standaloneErrorMessages.CART_COULD_NOT_BE_FOUND.end)
  );
}

export const isItemToAddSoldOut = errorMessage =>
  errorMessage.startsWith(
    standaloneErrorMessages.COULD_NOT_ADD_ITEM_SOLD_OUT_INVENTORY.start
  ) &&
  errorMessage.endsWith(
    standaloneErrorMessages.COULD_NOT_ADD_ITEM_SOLD_OUT_INVENTORY.end
  );

export const isItemToAddWouldExceedInventory = errorMessage =>
  errorMessage.startsWith(
    standaloneErrorMessages.COULD_NOT_ADD_ITEM_WOULD_EXCEED_INVENTORY.start
  ) &&
  errorMessage.endsWith(
    standaloneErrorMessages.COULD_NOT_ADD_ITEM_WOULD_EXCEED_INVENTORY.end
  );

export const formatAddItemInventoryErrorMessageForModal = errorMessage => {
  let title = 'Sorry, that item could not be added';
  let text = 'We have a limited quantity of the requested item';

  if (errorMessage && typeof errorMessage === 'string') {
    const messageParts = errorMessage.split('.');

    const titlePart = messageParts?.[0];
    if (titlePart) {
      title = titlePart.trim();
    }

    const textPart = messageParts?.[1];
    if (textPart) {
      text = textPart.trim();
    }
  }

  text = `${text}.`;

  return { title, text };
};
